import { render, staticRenderFns } from "./GlassWidget.vue?vue&type=template&id=fce7f9c4&scoped=true"
import script from "./GlassWidget.vue?vue&type=script&lang=js"
export * from "./GlassWidget.vue?vue&type=script&lang=js"
import style0 from "./GlassWidget.vue?vue&type=style&index=0&id=fce7f9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce7f9c4",
  null
  
)

export default component.exports